import { IsiAssociatedView } from "../../../IsiWebGUI/IsiFW/Components/Grid/IsiAssociatedView.component";
import { IIsiUIFlowResult } from "../../Core/IIsiUIFlowResult";
import { IsiDetailManager } from "./IsiAssociatedViewManager";
import { IsiIWSAssociatedViewContext } from "./IsiIwsAssociatedViewContext";

/**
 * Provider qui gère la dissociation.
 * */
export class IsiDissociationProvider {

    /**
     * Méthode qui lance la dissociation
     * @param associatedViewContext le context d'execution de la dissociation
     * @param associatedViewManager le manager de données associées
     */
    dissociate(associatedViewContext: IsiIWSAssociatedViewContext,associatedViewManager: IsiDetailManager): Promise<IIsiUIFlowResult> {
        return new Promise((resolve, reject) => {
            associatedViewManager.getInstanceOfAssociatedViewFromContext(associatedViewContext).then((assView) => {
                assView.beforeDissociate(associatedViewContext).then((flow) => {
                    resolve(flow);
                });
            })
                .catch(() => {
                    reject(true);
                })
            
        })
    }
}
